<template>
  <div id="FormTableComponent">
    <v-card class="p-4">
      <v-spacer />
      <v-card-title>
        <v-text-field
          v-model="search"
          class="mb-4"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          filled
          rounded
        />
      </v-card-title>
      <v-card-text>
        <v-data-table
          v-model="selected"
          :headers="formTable.headers"
          :items="formTable.items"
          item-key="Name"
          sort-by="updated_at_unix"
          sort-desc
          :loading="loading"
          :search="search"
          :custom-filter="customFormFilter"
          :options.sync="tableOptions"
          @update:items-per-page="saveLocalItemsPerPage($event)"
        >
          <template v-slot:no-data>
            <div class="my-4">
              <p>No forms found</p>
              <v-btn
                color="green"
                dark
                @click="$router.push({ name: 'forms.create' })"
              >
                Create Form
              </v-btn>
            </div>
          </template>
          <template v-slot:loading>
            <div class="my-4">
              <p>Loading forms...</p>
            </div>
          </template>
          <template v-slot:[`item.is_global`]="{ item }">
            <v-icon
              v-if="!!item.is_global"
              class="m-2"
              color="green"
            >
              mdi-earth
            </v-icon>
          </template>
          <template v-slot:[`item.is_draft`]="{ item }">
            <v-icon
              v-if="!item.is_draft"
              class="m-2"
              color="green"
            >
              mdi-check
            </v-icon>
            <v-icon
              v-else
              class="m-2"
              color="red"
            >
              mdi-close
            </v-icon>
          </template>
          <template v-slot:[`item.updated_at_unix`]="{ item }">
            {{ item.updated_at }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn
              title="copy"
              color="agency-color-primary"
              class="white--text"
              fab
              small
              depressed
              @click="copy(item)"
            >
              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
            <v-btn
              title="edit"
              color="agency-color-primary"
              class="white--text"
              :to="{ name: 'forms.edit', params: { id: item.id } }"
              :disabled="!!item.is_global && !is_admin"
              fab
              small
              depressed
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn
              title="preview"
              color="agency-color-primary"
              class="white--text"
              :to="{ name: 'forms.preview', params: { id: item.id } }"
              fab
              small
              depressed
            >
              <v-icon>mdi-eye</v-icon>
            </v-btn>
            <v-btn
              v-if="item.is_draft"
              title="publish"
              color="agency-color-primary"
              class="white--text"
              :disabled="!!item.is_global && !is_admin"
              fab
              small
              depressed
              @click="publishForm(item)"
            >
              <v-icon>mdi-publish</v-icon>
            </v-btn>
            <v-btn
              v-else
              title="disable"
              color="agency-color-primary"
              class="white--text"
              :disabled="!!item.is_global && !is_admin"
              fab
              small
              depressed
              @click="prompt(item, 'disable')"
            >
              <v-icon>mdi-cancel</v-icon>
            </v-btn>
            <v-btn
              title="results"
              color="agency-color-primary"
              class="white--text"
              :to="{ name: 'forms.result', params: { id: item.id } }"
              fab
              small
              depressed
            >
              <v-icon>mdi-chart-bar</v-icon>
            </v-btn>
            <v-btn
              title="delete"
              color="red"
              class="white--text"
              :disabled="!!item.is_global && !is_admin"
              fab
              small
              depressed
              @click="prompt(item, 'delete')"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="actionDialog"
      max-width="350"
      attach
    >
      <v-card
        :loading="actionDialogLoading"
        :disabled="actionDialogLoading"
      >
        <v-card-title class="headline">
          Are you sure?
        </v-card-title>
        <v-card-text>
          <small>
            <b>{{ actionItem.additional_info }}</b>
          </small>
          <br>
          Are you sure you want to {{ action }} {{ actionItem.name }}?
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="red"
            text
            @click="actionDialog = false"
          >
            Cancel
          </v-btn>
          <v-spacer />
          <v-btn
            color="green"
            text
            @click="confirm()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: 'FormTableComponent',
  props: {
    //
  },
  data: () => ({
    selected: [],
    loading: true,
    search: '',
    formTable: {
      headers: [
        {
          text: 'Name',
          value: 'form_name'
        },
        {
          text: 'Global',
          value: 'is_global'
        },
        {
          text: 'Live',
          value: 'is_draft'
        },
        {
          text: 'Last Updated',
          value: 'updated_at_unix'
        },

        {
          text: 'Actions',
          value: 'actions',
          align: 'end',
          sortable: false
        }
      ],
      items: []
    },
    action: '',
    actionDialog: false,
    actionItem: {},
    actionDialogLoading: false
  }),
  computed: {
    is_admin () {
      return this.$store.state.users.user.is_admin
    }
  },
  created () {
    this.load()
  },
  methods: {
    prompt (item, action) {
      this.actionDialog = true
      this.action = action
      this.actionItem = item
      this.actionItem.name = item.form_name
      if (action === 'delete') {
        this.actionItem.additional_info =
        'Warning: Deleting this form will also delete all related form data'
      }
    },
    load () {
      const self = this
      self.LoadStateDependencies(['forms.forms', 'questions.types']).then(() => {
        self.formTable.items = self.$store.state.forms.forms
        self.loading = false
      })
    },
    confirm () {
      switch (this.action) {
        case 'delete':
          this.deleteForm()
          break
        case 'disable':
          this.disableForm()
          break

        default:
          break
      }
    },
    copy (item) {
      const self = this // Vue instance
      self.loading = true

      self.$store.dispatch('forms/copyForm', { id: item.id }).then(
        response => {
          self.$router.push({ name: 'forms.edit', params: { id: response.data.id } })
        },
        error => {
          self.loading = false
          alert('There was an error copying your form.')
          self.$emit('error', error)
        })
    },
    deleteForm () {
      const self = this
      self.actionDialogLoading = true
      self.loading = true
      self.$store
        .dispatch('forms/deleteForm', self.actionItem)
        .then(response => {
          self.actionDialogLoading = false
          self.actionDialog = false
          self.loading = false
          this.load()
        })
    },
    publishForm (item) {
      const self = this
      item.is_draft = 0
      this.$store.dispatch('forms/publishForm', { id: item.id })
        .catch(error => {
          alert('There was an error publishing your form.')
          self.$emit('error', error)
        })
    },
    disableForm () {
      const self = this
      self.actionItem.is_draft = 1
      self.$store.dispatch('forms/disableForm', self.actionItem)
        .then(() => { self.actionDialog = false })
        .catch(error => {
          alert('There was an error publishing your form.')
          self.$emit('error', error)
        })
    },
    customFormFilter (value, search, item) {
      if (!search) {
        return true
      }

      const searchTerm = search.toString().toLowerCase()

      return [
        item.form_name,
        item.candidate_names
      ].some(field => {
        return field &&
          field.toString().toLowerCase().includes(searchTerm)
      })
    }
  }
}
</script>
